import React, { type ReactNode, useState, type MouseEvent } from 'react'
import { Tooltip } from '@mui/material'

interface CopyableTooltipProps {
  content: string
  children: ReactNode
}

export default function CopyableTooltip({
  content,
  children,
}: CopyableTooltipProps) {
  const [open, setOpen] = useState(false)
  const [tooltipText, setTooltipText] = useState(content)
  const [clicked, setClicked] = useState(false)

  const resetTooltip = () => {
    setTimeout(() => {
      setTooltipText(content)
      setOpen(false)
      setClicked(false)
    }, 1200)
  }

  const handleClick = async (e: MouseEvent<HTMLSpanElement>) => {
    e.stopPropagation()
    setClicked(true)
    try {
      await navigator.clipboard.writeText(content)
      setTooltipText('Copied!')
      setOpen(true)
      resetTooltip()
    } catch (err) {
      setTooltipText('Failed to copy')
      setOpen(true)
      resetTooltip()
    }
  }

  const handleTooltipOpen = () => {
    if (!clicked) {
      setTooltipText(content)
      setOpen(true)
    }
  }

  const handleTooltipClose = () => {
    if (!clicked) {
      setOpen(false)
    }
  }

  return (
    <Tooltip
      title={tooltipText}
      open={open}
      onOpen={handleTooltipOpen}
      onClose={handleTooltipClose}
      disableInteractive
    >
      <span
        onClick={handleClick}
        style={{ display: 'inline-block', cursor: 'pointer' }}
      >
        {children}
      </span>
    </Tooltip>
  )
}
